import './style.css';
import './brand.css';
import './motion.css';
import './product.css';
import './impact.css';
import './dashboard.css';
import './fidelity.css';
import './module-atlas.css';
import './refresh.css';
import './performance.css';
import './growth.css';
import './stories.css';
import './consent.css';
import { pageFor } from './growth';
import { legacyRoutes } from './route-redirects';
import { installMetadata } from './seo';
import { installAnalytics } from './analytics';

// Vite's local fallback does not run the Pages worker. Keep old bookmarks usable
// locally too, preserving query parameters and section anchors.
const legacyPath = legacyRoutes[location.pathname.replace(/\/+$/, '') || '/'];
if (legacyPath) history.replaceState(history.state, '', legacyPath + location.search + location.hash);
const page = pageFor(location.pathname);
installMetadata(page);
installAnalytics(page.path);
if (page.path === '/') {
  await import('./main');
} else {
  const app = document.querySelector<HTMLDivElement>('#app')!;
  if (app.querySelector<HTMLElement>('[data-page]')?.dataset.page !== page.path) {
    const { pageMarkup } = await import('./pages');
    app.innerHTML = pageMarkup(page);
  }
  const { installPage } = await import('./page-client');
  await installPage(page);
}

if (document.querySelector('[data-story-motion]')) {
  const { installStoriesMotion } = await import('./stories-motion');
  installStoriesMotion();
}
